import type { AxiosResponse } from 'axios'
import i18n from '@/i18n'
import { LANGEXT_LANGUAGE_KEYS, isAppLocale } from '@/constants/appLocale'

export default (response: AxiosResponse) => {
  const lng = i18n.language
  const locale = isAppLocale(lng) ? lng : 'zh_CN'
  const langKeys = LANGEXT_LANGUAGE_KEYS[locale]
  const cloneI18nProps = (params: any) => {
    switch (Object.prototype.toString.call(params)) {
      case '[object Array]': {
        return params.map(cloneI18nProps)
      }
      case '[object Object]': {
        let translation: Record<string, string> = {}
        const langKey = ['langExt']
        langKey.forEach(key => {
          if(params[key]) {
            try {
              const langExtJson = JSON.parse(params[key]) as Record<string, Record<string, string> | undefined>
              for (const apiKey of langKeys) {
                const entry = langExtJson[apiKey]
                if (entry) {
                  Object.assign(translation, entry)
                  break
                }
              }
            } catch {
              // langExt 不是有效 JSON 时跳过
            }
          }
        })
        try {
          Object.keys(params).forEach(key => {
            if (langKey.indexOf(key) < 0) {
              if (params[key] && typeof params[key] === 'object') {
                params[key] = cloneI18nProps(params[key])
              } else {
                params[key] = translation[key] || params[key]
              }
            }
          })
          return params
        } catch (error) {
          console.error('i18n middlewares cloneI18nProps error', error, { translation, params })
          return params
        }

      }
      default: {
        return params;
      }
    }
  }
  try {
    const newData = cloneI18nProps(response.data)
    response.data = newData;
  } catch (error) {
  }
  
  return response;
}